import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { usePortal } from './PortalAuth';
import { Spinner } from './ui';
import { usePortalTheme } from './theme';
import { savePref } from './prefs';
import ExecutiveShell from './shells/ExecutiveShell';
import RossoShell from './shells/RossoShell';
import DesignChooser from './DesignChooser';
import InstallBanner from './InstallBanner';
import PasskeyPrompt from './PasskeyPrompt';
import { api } from './api';
import { canSee, sectionOf } from './shells/nav';
import './themes.css';
import './designs.css';

export default function PortalLayout() {
  const { user, loading, signOut, refresh } = usePortal();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { theme, setTheme, chosen } = usePortalTheme(user);

  if (loading) return <div className="min-h-screen bg-[#050505]"><Spinner /></div>;
  if (!user) return <Navigate to="/portal/login" replace />;
  if (!canSee(user, sectionOf(pathname))) return <Navigate to="/portal" replace />;

  const logout = () => { signOut(); navigate('/portal/login'); };
  const Shell = theme === 'rosso' ? RossoShell : ExecutiveShell;
  const confirm = async () => { await savePref('theme', theme); await refresh(); };

  return (
    <>
      <Shell user={user} onLogout={logout} ctx={{ design: theme, setDesign: setTheme }} />
      {!chosen && <DesignChooser value={theme} onPreview={(t) => setTheme(t, false)} onConfirm={confirm} />}
      {chosen && <InstallBanner />}
      {chosen && <PasskeyPrompt who={user.email} client={api} base="/auth/passkeys" />}
    </>
  );
}
